import { assertNever } from "@p0security/shared/types/index";

export const NODE_HEADER_HEIGHT = 20;

export const DiscoverFlowSizes = {
  oneLine: {
    large: {
      height: 52 + NODE_HEADER_HEIGHT,
      width: 250,
    },
    small: {
      height: 52,
      width: 250,
    },
  },
  twoLine: {
    large: {
      height: 72 + NODE_HEADER_HEIGHT,
      width: 250,
    },
    small: {
      height: 72,
      width: 250,
    },
  },
};

export const convertFlowSize = (size: 1 | 2) =>
  size === 1
    ? DiscoverFlowSizes.oneLine
    : size === 2
      ? DiscoverFlowSizes.twoLine
      : assertNever(size);
